import { render, staticRenderFns } from "./StreamMediaLinks.vue?vue&type=template&id=6df31815&scoped=true"
import script from "./StreamMediaLinks.vue?vue&type=script&lang=js"
export * from "./StreamMediaLinks.vue?vue&type=script&lang=js"
import style0 from "./StreamMediaLinks.vue?vue&type=style&index=0&id=6df31815&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df31815",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6df31815')) {
      api.createRecord('6df31815', component.options)
    } else {
      api.reload('6df31815', component.options)
    }
    module.hot.accept("./StreamMediaLinks.vue?vue&type=template&id=6df31815&scoped=true", function () {
      api.rerender('6df31815', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/components/editor/StreamMediaLinks.vue"
export default component.exports